import { defineStore } from "pinia";
import { instance } from "./index";

const store = defineStore({
  id: "course-student",
  state: () => ({
    isAdaptive: JSON.parse(localStorage.getItem("course-type") as string),
  }),
  getters: {
    getIsAdaptive: (state) => state.isAdaptive,
  },
  actions: {
    setIsAdaptive(value: boolean) {
      this.isAdaptive = value;
    },
  },
});

export const useCourseStudentStore = store(instance);
